import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const loader = () => import( /* webpackChunkName: "Title" */'./Title');
export default Loadable({
  loader,
  LoadingComponent: () => /*#__PURE__*/_jsx(View, {
    inlineSize: "300px",
    blockSize: "30px",
    backgroundColor: "fill-primary-disabled",
    display: "inline-block"
  })
});